<template>
  <div class="container">
    <div class="row">
      <div 
        v-if="hasTableName"
        class="col-12 col-xl-auto mb-2"
      >
        <b-button-group>
          <b-form-select
            v-model="table"
            :options="tableOptions"
            class="mt-2 mt-lg-0"
            @change="applyFilters"
          />
        </b-button-group>
      </div>
      <div class="col-12 col-xl-auto mb-2">
        <b-button
          variant="outline-success"
          :class="[{ active: statusFilter === 'succeeded' }, 'status-btns']"
          @click="setStatusFilter('succeeded')"
        >
          Succeeded
        </b-button>
        <b-button
          variant="outline-danger"
          :class="[{ active: statusFilter === 'failed' }, 'status-btns']"
          @click="setStatusFilter('failed')"
        >
          Failed
        </b-button>
        <b-button
          variant="outline-secondary"
          :class="{ active: !statusFilter }"
          @click="setStatusFilter(null)"
        >
          All
        </b-button>
      </div>

      <div class="w-100 d-none d-lg-block d-xl-none mt-1" />
      <div class="col-12 col-xl-auto mb-2">
        <b-form>
          <div class="d-flex flex-column flex-lg-row">
            <custom-date-picker
              id="startTimeFrom"
              v-model="startTimeFrom"
              class="mr-2"
              input-class="input-editor form-control"
              type="datetime"
              format="YYYY-MM-DD HH:mm:ss"
              placeholder="Start Time From"
              @change="applyFilters"
            />
            <custom-date-picker
              id="startTimeTo"
              v-model="startTimeTo"
              input-class="input-editor form-control"
              type="datetime"
              format="YYYY-MM-DD HH:mm:ss"
              placeholder="Start Time To"
              @change="applyFilters"
            />
          </div>
        </b-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      statusFilter: null,
      startTimeFrom: null,
      startTimeTo: null,
      table: null,
    };
  },
  computed:{
    hasTableName() {
      return this.items.some(item => item.TableName);
    },
    tableOptions() {
      const names = [...new Set(this.items.map(i => i.TableName).filter(Boolean))];
      return [{ value: null, text: 'All Tables' }, ...names.map(n => ({ value: n, text: n }))];
    },
  },
  methods: {
    applyFilters() {
      let filteredItems = this.items;

      // Filter by status
      if (this.statusFilter) {
        filteredItems = filteredItems.filter(item => item.UploadStatusName === this.statusFilter);
      }

      // Filter by start time
      const startFrom = this.startTimeFrom || null;
      const startTo = this.startTimeTo || null;;

      filteredItems = filteredItems.filter(item => {
        const itemStartTime = this.parseDateTime(item.StartTime);
        const afterFrom = !startFrom || itemStartTime >= startFrom;
        const beforeTo = !startTo || itemStartTime <= startTo;
        return afterFrom && beforeTo;
      });
      if (this.table) {
        filteredItems = filteredItems.filter(item => item.TableName === this.table);
      }

      this.$emit('filtered', filteredItems);
    },
    setStatusFilter(status) {
      this.statusFilter = status;
      this.applyFilters();
    },
    parseDateTime(dateTimeStr) {
      if (!dateTimeStr) return null;
      const date = new Date(dateTimeStr.replace(' ', 'T'));
      return isNaN(date.getTime()) ? null : date;
    },
  },
};
</script>

<style scoped>
.status-btns {
  width: 90px;
}

::v-deep .input-group {
  width: 280px;
}

::v-deep .input-group-text {
  width: 120px;
}
.container{
  margin: 0px;
  padding: 0px;
}
</style>